import initOurRangeNewVehicles from './initOurRangeNewVehicles';

const ourRangeNewVehicles = document.querySelectorAll('.cms-content-our-range-single-brand')
const ourRangeNewVehiclesLength = ourRangeNewVehicles.length;
if (ourRangeNewVehiclesLength > 0) {
    for (let index = 0; index < ourRangeNewVehiclesLength; index++) {
        initOurRangeNewVehicles(ourRangeNewVehicles[index]);
    }
}